module.exports = __webpack_public_path__ + "img/I2C_Fig03.79db88c7.png";